<template>
	<div>
		forward...
	</div>
</template>

<script>

export default {
	name: 'MilesSubsidyForward',
	components:{
		
	},
	data(){
  	return {
  		relatedTodoId:0
  	}
	},
	methods:{
		loadData(){
			this.request.get("/todo/" + this.relatedTodoId).then(res => {
        if (res.code === '200') {
        	this.$router.push(res.data.todoUrl + res.data.id + "?from=req_miles_statistic")
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
		}
	},
	mounted(){
		this.relatedTodoId = this.$route.params.relatedTodoId
		console.log('this.relatedTodoId:', this.relatedTodoId)
		this.loadData()
	}
}

</script>

<style scoped>
	
</style>